import React from 'react';
import ISDNRedirectTable from '../isdn-redirect-table/isdn-redirect-table';
import TextWithTooltip from '../../../../components/text-with-tooltip/text-with-tooltip';
import FormError from '../../../../components/form/error/error';
import { Desktop, Mobile } from '../../../../app-responsive';
import './isdn-redirect-service-details.css';

const ISDNRedirectServiceDetails = (props) => {
  const {
    serviceDetailsHeadingText,
    servicesErrorMessageText,
  } = props.authorableContent.authorableSiteData;
  const {
    siteServices,
    onRedirectCancelClick,
    isdnRedirectCancelChecks,
    siteId,
    handleOnChangeRedirectNumber,
    handleOnBlurRedirectNumber,
    isdnRedirectNumberData,
    handleOnBlurRedirectType,
    isdnRedirectTypeData,
    isdnRedirectNumberFieldError,
    showServicesErrorMessage,
    inDial,
  } = props;

  const redirectTableContent = {
    gdnText: props.authorableContent.isdnServiceDetails.gdnText,
    primaryFNN: props.authorableContent.isdnServiceDetails.primaryFNN,
    auxillary: props.authorableContent.isdnServiceDetails.auxillary,
    currentServiceDetailsText: props.authorableContent.authorableSiteData.currentServiceDetailsText,
    confirmOrderText: props.authorableContent.authorableSiteData.confirmOrderText,
    typeText: props.authorableContent.isdnServiceDetails.typeHeadingText,
    typeTooltipText: props.authorableContent.isdnServiceDetails.typeTooltipText,
    fnnText: props.authorableContent.isdnServiceDetails.fnnHeadingText,
    redirectAllText: props.authorableContent.authorableSiteData.redirectAllLabel,
    cancelAllText: props.authorableContent.authorableSiteData.cancelAllLabel,
    redirectText: props.authorableContent.authorableSiteData.redirectLabel,
    cancelText: props.authorableContent.authorableSiteData.cancelLabel,
    isdnRedirectDropDown: props.authorableContent.authorableSiteData.formFields.redirectType,
    isdnRedirectNumberTextField: props.authorableContent.authorableSiteData.formFields.redirectNumber,
    redirectWithPrimaryNumber: props.authorableContent.isdnServiceDetails.redirectWithPrimaryNumber,
  };
  const {
    title: estimatedOnceOffTitle,
    tooltip: estimatedOnceOffToolTip,
  } = props.authorableContent.serviceTermAuthorableContent.estimatedOnceoffChargesRental;

  const {
    title: estimatedMonthlyTitle,
    tooltip: estimatedMonthlyToolTip,
  } = props.authorableContent.serviceTermAuthorableContent.estimatedMonthlyChargesRental;

  const { perMonthLabel, priceConfirmedText } = props.authorableContent.serviceTermAuthorableContent;

  const { redirectCancelTotalCostInfoText } = props.authorableContent.isdnServiceDetails;

  const siteServicesArray = [];

  siteServices.forEach((parentService) => {
    siteServicesArray.push({ type: parentService.type, number: parentService.number, primaryFNN: '' });
    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number, primaryFNN: childService.number });

        childService.auxList.forEach((auxService) => {
          siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: childService.number });
        });
      });
    } else {
      parentService.auxList.forEach((auxService) => {
        siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: parentService.number });
      });
    }
  });


  const isRedirectSelected = () => {
    let redirectFound = false;
    siteServicesArray.forEach((service) => {
      if (redirectFound === false && isdnRedirectCancelChecks && isdnRedirectCancelChecks[`redirect-${service.type}-${service.number}`]) {
        redirectFound = true;
      }
    });
    return redirectFound;
  };

  return (
    <div className="isdn-redirect-service-section">
      {inDial === false &&
      <React.Fragment>
        <div className="row">
          <div className="col-12 pl-sm-0">
            <h2 id="service-heading" className="service-heading">{serviceDetailsHeadingText}</h2>
          </div>
        </div>
        <div id="services-error-section" className="has-error untouched">
          {(showServicesErrorMessage && servicesErrorMessageText)
            && <FormError errorText={servicesErrorMessageText} />
          }
        </div>
        <ISDNRedirectTable
          siteServicesArray={siteServicesArray}
          authorableContent={redirectTableContent}
          onRedirectCancelClick={onRedirectCancelClick}
          isdnRedirectCancelChecks={isdnRedirectCancelChecks}
          handleOnChangeRedirectNumber={handleOnChangeRedirectNumber}
          handleOnBlurRedirectNumber={handleOnBlurRedirectNumber}
          onIsdnRedirectTypeSelectionBlur={handleOnBlurRedirectType}
          siteId={siteId}
          isdnRedirectNumberData={isdnRedirectNumberData}
          isdnRedirectTypeData={isdnRedirectTypeData}
          isdnRedirectNumberFieldError={isdnRedirectNumberFieldError}
          showServicesErrorMessage={showServicesErrorMessage}
        />
      </React.Fragment>
      }
      <Desktop>
        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-description">
            <div>
              {estimatedOnceOffTitle}
              {isRedirectSelected() &&
                priceConfirmedText
              }
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-once-off-cost-tooltip"
                toolTipText={estimatedOnceOffToolTip}
              />
            </div>
          </div>

          <div className="col-md-6 estimated-monthly-cost estimated-cost-description">
            <div>
              {estimatedMonthlyTitle}
              {isRedirectSelected() &&
                priceConfirmedText
              }
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-6 estimated-once-off-cost estimated-cost-price">
            <div>
              <div className="total-price-estimate">
                {isRedirectSelected() === false &&
                  <React.Fragment>
                    <sup>$</sup><span>0</span>
                  </React.Fragment>
                }
                &nbsp;
              </div>
            </div>
          </div>
          <div className="col-md-6 estimated-monthly-cost estimated-cost-price">
            <div className="total-price-estimate">
              {isRedirectSelected() === false &&
                <React.Fragment>
                  <sup>$</sup>0<sub>{perMonthLabel}</sub>
                </React.Fragment>
              }
              &nbsp;
            </div>
          </div>
          <div className="col-12">
            <strong>{redirectCancelTotalCostInfoText}</strong>
          </div>
        </div>
      </Desktop>
      <Mobile>
        <div className="row estimated-once-off-cost mobile-seperation">
          <div className="col-12 estimated-cost-description">
            {estimatedOnceOffTitle}
            {isRedirectSelected() &&
                priceConfirmedText
            }
            <TextWithTooltip
              text={<i className="td-icon icon-help" />}
              textClassName="help-icon-container"
              id="estimated-once-off-cost-tooltip"
              toolTipText={estimatedOnceOffToolTip}
            />
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate">
              {isRedirectSelected() === false &&
                <React.Fragment>
                  <sup>$</sup><span>0</span>
                </React.Fragment>
              }
              &nbsp;
            </div>
          </div>
        </div>

        <div className="row estimated-monthly-cost">
          <div className="col-12  estimated-cost-description">
            <div>
              {estimatedMonthlyTitle}
              {isRedirectSelected() &&
                priceConfirmedText
              }
              <TextWithTooltip
                text={<i className="td-icon icon-help" />}
                textClassName="help-icon-container"
                id="estimated-monthly-cost-tooltip"
                toolTipText={estimatedMonthlyToolTip}
              />
            </div>
          </div>
          <div className="col-12 estimated-cost-price">
            <div className="mobile-totals total-price-estimate">
              {isRedirectSelected() === false &&
                <React.Fragment>
                  <sup>$</sup>0<sub>{perMonthLabel}</sub>
                </React.Fragment>
              }
              &nbsp;
            </div>
          </div>
        </div>
      </Mobile>
    </div>
  );
};

export default ISDNRedirectServiceDetails;

